module.exports = __webpack_public_path__ + "imgs/archii-dark-white.svg";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/img/archii-dark-white.svg
// module id = 551
// module chunks = 0